module.exports = __webpack_public_path__ + "static/img/loading-icon-stats.f719861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stats/loading-icon-stats.png
// module id = 532
// module chunks = 3 4 5 6